define('home/templates/settingsBlockingEmpty',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p class=\"text-gray text-medium\">\n"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"You aren't blocking any users. To block a user, go to their profile and select \"Block User\" from the dropdown.",{"name":"gettext","hash":{},"data":data}))
    + "\n</p>\n";
},"useData":true})

});
